import { render, staticRenderFns } from "./stock-trace.vue?vue&type=template&id=680bb504"
import script from "./stock-trace.vue?vue&type=script&lang=js"
export * from "./stock-trace.vue?vue&type=script&lang=js"
import style0 from "./stock-trace.vue?vue&type=style&index=0&id=680bb504&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports